const Reservation = () => {
  return <h1>This is Reservation</h1>;
};

export default Reservation;
